<template>
    <div class="group">
        <label v-on:click="active = true">First name</label>
        <input type="text" class="validation" v-bind:class="{ '-invalid': $parent.validation.firstname } "  v-model="$parent.fields.firstname" v-on:keyup="$parent.validation.firstname = null" @focus="active = true" @blur="blur('firstname')" ref="el">
        <div class="error-message" v-for="message in $parent.validation.firstname">{{ message }}</div>
    </div>
</template>

<script>
    import mixin from './mixin';

    export default {
        name: 'firstname',
        data() {
            return {
                active: false
            }
        },
        mixins: [ mixin ]
    }
</script>
